import { UserStatusType } from '@pt/models';

export const userStatusTypes: UserStatusType[] = ['probation', 'active', 'offboarding'];
